:host {
  display: block;

  --col-count: 1;

  .container {
    gap: 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;

    .loading-section {
      height: 250px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loading-shop-card {
      width: calc(100% / var(--col-count) - 20px);
    }

    .shop-card {
      display: flex;
      flex-direction: column;
      width: calc(100% / var(--col-count) - 20px);
      background: var(--white);
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease;

      color: unset;
      text-decoration: unset;

      &:last-of-type {
        margin-right: auto;
      }

      &:hover {
        transform: scale(1.05);
        cursor: pointer;
      }

      .poster {
        position: relative;
        height: 140px;
        width: 100%;
        object-fit: cover;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .event-count-pill {
          position: absolute;
          top: 10px;
          right: 10px;
          background: $main-color;
          background: var(--main-color);
          color: $white;
          color: var(--white);
          padding: 4px 8px;
          font-size: 12px;
          font-weight: bold;
          border-radius: 12px;
          text-transform: uppercase;
        }
      }

      .infos {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .title {
          font-size: 17px;
          line-height: 22px;
          font-weight: 600;
          color: $gray-dark;
          color: var(--gray-dark);
        }

        .date-range {
          font-size: 14px;
          line-height: 18px;
          font-weight: 500;
          color: $gray-medium;
          color: var(--gray-medium);
        }

        .places {
          font-size: 14px;
          line-height: 18px;
          font-weight: 450;
          color: $gray-medium;
          color: var(--gray-medium);
        }
      }
    }

    .no-default-shop {
      font-size: 18px;
      line-height: 28px;
      font-weight: 450;
      color: $gray-dark;
      color: var(--gray-dark);
      margin: 20px 0;
      display: flex;
      flex-direction: column;
      width: 100%;

      .other-events-button {
        border: none;
        color: $white;
        color: var(--white);
        font-size: 16px;
        margin-top: 18px;
        font-weight: 600;
        line-height: 25px;
        text-align: center;
        padding: 12px 20px;
        width: fit-content;
        border-radius: 60px;
        text-decoration: none;
        background: $main-color;
        background: var(--main-color);
      }
    }

    .fake-cards {
      display: flex;
      margin-top: 80px;
      justify-content: space-between;

      .fake-card {
        height: 265px;
        width: calc(100% / var(--col-count) - 20px);
        background: white;
        border-radius: 10px;
        background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF00 100%);
      }
    }

    &.is-portal {
      margin-top: 80px;
    }
  }
}

@media (min-width: 1600px) {
  :host {
    .is-modal {
      --col-count: 3 !important;
    }
  }
}

@media (min-width: 1200px) {
  :host {
    --col-count: 4;

    .is-modal {
      --col-count: 2;
    }
  }
}

@media (min-width: 800px) and (max-width: 1200px) {
  :host {
    --col-count: 3;

    .fake-card:nth-of-type(n + 4) {
      display: none;
    }

    .is-modal {
      --col-count: 1;
      justify-content: center;
    }
  }
}

@media (min-width: 450px) and (max-width: 800px) {
  :host {
    --col-count: 2;

    .fake-card:nth-of-type(n + 3) {
      display: none;
    }

    .is-modal {
      --col-count: 1;
      justify-content: center;
    }
  }
}

@media (max-width: 450px) {
  :host {
    --col-count: 1;

    .fake-cards {
      justify-content: center !important;
    }

    .fake-card:nth-of-type(n + 2) {
      display: none;
    }
  }
}
